import React, { useState, useRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { FileUpload } from "primereact/fileupload";
import DownloadListItem from "./DownloadListItemForm";
// import { Label, InputText } from "../../../../components/Inputs";
import {
  getContentTypeIdFromType,
  CONTENT_DOWNLOAD_LIST,
  getFileTitleFromName,
  getFileTypeLabel,
  formatFileSize
} from "../Utils";
import { handleUploadError } from "../../../../components/Utils";

const DownloadListForm = React.forwardRef(({ className, model, uploadUrl, multiple, accepted }, ref) => {
  const itemFormRefs = useRef([]);
  let initialFiles = [];
  try {
    initialFiles = JSON.parse(model.body || "[]");
  } catch(err) {
    console.error("Error:", model, err);
  }
  const [files, setFiles] = useState(initialFiles);

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      const body = files.map((file, index) => {
        const data = itemFormRefs.current[index].getModel(noValidate);
        return { ...file, ...data };
      });
      return {
        id: model.id,
        content_type_id: getContentTypeIdFromType(CONTENT_DOWNLOAD_LIST),
        body: JSON.stringify(body)
      };
    }
  }), [files, model]);

  const addFile = (event) => {
    // console.log("DownloadListForm.addFile()", event);
    const response = JSON.parse(event.xhr.response);
    const newFiles = multiple ? response : [ response ];
    const items = newFiles.map((item, index) => {
      const date = item.date || item.created_date || item.createdDate;
      return {
        path: "/data-api" + item.filePath,
        title: getFileTitleFromName(item.fileName),
        type: getFileTypeLabel(item.fileName),
        size: formatFileSize(event.files[index].size),
        date: (date ? moment(date, "YYYY-MM-DDTHH:mm:ss:SSSZ") : moment()).format("DD.MM.YYYY")
      };
    });
    setFiles([ ...files ].concat(items));
    // console.log("New Items:", items, files);
  };

  const removeFile = (currentIndex) => {
    setFiles(files.filter((_, index) => index !== currentIndex));
  };

  const move = (currentIndex, up) => {
    const targetIndex = up ? currentIndex - 1 : currentIndex + 1;
    const updated = [];
    const src = files[currentIndex];
    const tgt = files[targetIndex];
    for (let index = 0; index < files.length; index++) {
      if (index === currentIndex) {
        updated.push(tgt);
      } else if (index === targetIndex) {
        updated.push(src);
      } else {
        updated.push({ ...files[index] });
      }
    }
    setFiles(updated);
  };

  console.log("DownloadListForm.render()", { className, model, uploadUrl, multiple, accepted });
  const prefix = Math.random();
  const listMarkup = files.map((item, index) => {
    const { title, type, date, size } = item;
    const props = { title, text: `${date} | ${type} ${size}` };
    return (
      <DownloadListItem
        key={`${prefix}${index}`}
        className="pad-sm-top"
        ref={el => { itemFormRefs.current[index] = el; }}
        {...props}
        onMoveUp={(index > 0) ? () => move(index, true) : null}
        onMoveDown={(index < files.length - 1) ? () => move(index, false) : null}
        onRemove={() => removeFile(index)}
      />
    );
  });

  return (
    <div className={`${className} pad`}>
      <div className="w3-row neg-margin-lr form">
        <div className="w3-col s9 pad-lr">
          <h4 className="no-margin pad-sm-tb">Liste</h4>
        </div>
        <div className="w3-col s3 pad-lr alg-right">
          <FileUpload
            name="file"
            // className="btn btn-primary"
            mode="basic"
            auto={true}
            url={uploadUrl}
            multiple={multiple}
            accept={accepted.join(",")}
            chooseLabel="Datei hochladen"
            onUpload={event => addFile(event)}
            onError={handleUploadError}
          />
        </div>
      </div>
      <div>{listMarkup}</div>
    </div>
  );
});

DownloadListForm.displayName = "DownloadListForm";

DownloadListForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.object,
  uploadUrl: PropTypes.string,
  multiple: PropTypes.bool,
  accepted: PropTypes.array,
};

DownloadListForm.defaultProps = {
  className: "",
  model: { body: "[]" },
  uploadUrl: "/data-api/media/upload",
  multiple: false,
  accepted: [
    ".pdf", ".doc", ".docx", ".docx", ".xls", ".xlsx", ".csv",
    ".zip", ".ppt", ".pptx"
  ],
};

export default DownloadListForm;
